import { h } from 'preact'
import PNFO from 'jlinc-shared/PNFO'

import classNames from 'lib/classNames'
import {
  usePublicOrganizationsWithActivity,
} from 'lib/membershipAppStateHooks'

import MyOrganizationsList from 'components/MyOrganizationsList'
import HeaderedContentBox from 'components/HeaderedContentBox'
import './index.sass'

export default function PublicOrganizationsWithActivityList({ className, textFilter, buttons, ...props }){
  const {
    activeOrganizations,
    inactiveOrganizations,
    publicOrganizationsWithActivityLoading,
    publicOrganizationsWithActivityLoadingError,
  } = usePublicOrganizationsWithActivity('PublicOrganizationsWithActivityList')

  const organizationsLoading = (
    !activeOrganizations ||
    !inactiveOrganizations ||
    publicOrganizationsWithActivityLoading
  )

  return <div className={classNames('PublicOrganizationsWithActivityList', {className})}>
    <HeaderedContentBox
      header={`Active ${PNFO.plural}`}
      icon="circle-thin"
      buttons={buttons}
    >
      <MyOrganizationsList {...{
        ...props,
        error: publicOrganizationsWithActivityLoadingError,
        className: 'ActiveOrganizationsList',
        organizationsLoading,
        organizations: activeOrganizations,
        textFilter,
        sort: false,
        onEmpty: `There are no active ${PNFO.plural}`,
      }}/>
    </HeaderedContentBox>

    <HeaderedContentBox
      header={`Ghost Town ${PNFO.plural}`}
      icon="moon"
      collapsable
      collapsedByDefault
    >
      <MyOrganizationsList {...{
        ...props,
        error: publicOrganizationsWithActivityLoadingError,
        className: 'InactiveOrganizationsList',
        organizationsLoading,
        organizations: inactiveOrganizations,
        textFilter,
        sort: false,
        onEmpty: `There are no inactive ${PNFO.plural}`,
      }}/>
    </HeaderedContentBox>
  </div>
}
